import { connect } from '@ardoq/rxbeach';
import { IconName } from '@ardoq/icons';
import { componentFab$ } from './componentFab$';
import { ButtonType, IconButton } from '@ardoq/button';
import styled from 'styled-components';
import { space } from '@ardoq/design-tokens';
import { ComponentFabProps } from './ComponentFab';
import { t } from '@ardoq/i18n';

const ComponentFabViewpointContainer = styled.div`
  position: absolute;
  right: ${space.large};
  bottom: ${space.medium};
  z-index: 1;
`;

const ComponentViewpointFabBase = ({
  isActive,
  isVisible,
  onClick,
  i18nLocale,
}: ComponentFabProps) => {
  if (!isVisible || isActive) {
    return null;
  }

  return (
    <ComponentFabViewpointContainer>
      <IconButton
        label={t(
          i18nLocale,
          'views:fab.componentFab.create',
          'Create a component'
        )}
        iconName={IconName.ADD}
        onClick={onClick}
        buttonType={ButtonType.TERTIARY}
      />
    </ComponentFabViewpointContainer>
  );
};

export const ComponentViewpointFab = connect(
  ComponentViewpointFabBase,
  componentFab$
);
